export enum Outcome {
  CambioIndirizzo = '4',
  Altro = 'X',
}
